class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    // Ouverture au survol sur desktop (souris) — comme sur satisfy.com : pas
    // besoin de cliquer. Le clic reste fonctionnel (clavier, tactile, trackpad
    // sans vrai hover) car on ne fait qu'ajouter/retirer l'attribut natif
    // `open`, qu'un clic sur le <summary> peut toujours basculer.
    this.hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
    this.querySelectorAll('details').forEach((details) => this.bindHover(details));
  }

  bindHover(details) {
    const isTopLevel = details === this.mainDetailsToggle;

    const closeNow = (target) => {
      clearTimeout(target._ciaoHoverTimer);
      target.open = false;
      target.querySelector(':scope > summary')?.setAttribute('aria-expanded', false);
      target.querySelectorAll('details[open]').forEach(closeNow);
      if (HeaderMenu.openTopLevel === target) HeaderMenu.openTopLevel = null;
    };

    details.addEventListener('mouseenter', () => {
      if (!this.hoverQuery.matches) return;
      clearTimeout(details._ciaoHoverTimer);
      // En passant directement d'un menu du haut à un autre, on ferme
      // l'ancien sans délai : sinon son délai de fermeture (ci-dessous) se
      // cumule avec l'animation d'ouverture du nouveau et ça donne
      // l'impression que le menu traîne de la patte.
      if (isTopLevel && HeaderMenu.openTopLevel && HeaderMenu.openTopLevel !== details) {
        closeNow(HeaderMenu.openTopLevel);
      }
      if (!details.open) details.open = true;
      if (isTopLevel) HeaderMenu.openTopLevel = details;
    });

    details.addEventListener('mouseleave', () => {
      if (!this.hoverQuery.matches) return;
      // Ce délai ne sert que pour une sortie « pour de vrai » du menu (la
      // souris quitte la nav entièrement) : il laisse le temps de descendre
      // en diagonale vers le contenu du sous-menu sans qu'il se referme.
      details._ciaoHoverTimer = setTimeout(() => closeNow(details), 150);
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

// Menu du haut actuellement ouvert au survol, partagé entre toutes les
// instances de <header-menu> (une par item de nav) pour permettre une
// fermeture immédiate de l'ancien quand on passe directement à un autre.
HeaderMenu.openTopLevel = null;

customElements.define('header-menu', HeaderMenu);
